import { render, staticRenderFns } from "./RealTime.vue?vue&type=template&id=a44ba52e&scoped=true"
import script from "./RealTime.vue?vue&type=script&lang=js"
export * from "./RealTime.vue?vue&type=script&lang=js"
import style0 from "./RealTime.vue?vue&type=style&index=0&id=a44ba52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44ba52e",
  null
  
)

export default component.exports